import { render, staticRenderFns } from "./Sidepop.vue?vue&type=template&id=5795398e&"
import script from "./Sidepop.vue?vue&type=script&lang=js&"
export * from "./Sidepop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports